module.exports = __webpack_public_path__ + "img/draw_bonus6.aca7c921.png";